import { useStorage } from './use-storage';

/**
 * Hook to simplify using a localStorage value
 */
export function useLocalStorage<T = any>(key: string, initialValue?: T) {
  return useStorage(key, 'localStorage', initialValue);
}

/**
 * Hook to simplify using a sessionStorage value
 */
export function useSessionStorage<T = any>(key: string, initialValue?: T) {
  return useStorage(key, 'sessionStorage', initialValue);
}
